module.exports.primaryNav = [
  {
    linkID: 'find-jobs',
    linkText: 'Find Jobs',
    url: '/job-search'
  },
  {
    linkID: 'articles',
    linkText: 'Articles',
    url: '/blog'
  },
  {
    linkID: 'videos',
    linkText: 'Videos',
    url: '/videos'
  }
];

module.exports.secondaryNav = [
  {
    linkID: 'for-employers',
    linkText: 'For Employers',
    url: '/employers'
  },
  // {
  //   linkID: 'events',
  //   linkText: 'Events',
  //   url: '/events'
  // },
  {
    linkID: 'contact',
    linkText: 'Contact',
    url: '/contact'
  }
];
